export const blockIconsAndroidBattery4BarNew = (
	<span className='material-symbols-outlined'>battery_4_bar</span>
);
